import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Inspiration from './inspiration';
import InspirationDetail from './inspiration-detail';
import InspirationUpdate from './inspiration-update';
import InspirationDeleteDialog from './inspiration-delete-dialog';

const InspirationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Inspiration />} />
    <Route path="new" element={<InspirationUpdate />} />
    <Route path=":id">
      <Route index element={<InspirationDetail />} />
      <Route path="edit" element={<InspirationUpdate />} />
      <Route path="delete" element={<InspirationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default InspirationRoutes;
